module.exports = __webpack_public_path__ + "media/images/emblems/Lancy-coat_of_arms-8a334916d8d14f7a0217564add4cdafd.svg";